export function buildLeaderboardPath(date, provider, limit = 100, offset = 0) {
  const params = new URLSearchParams({ date, provider, limit: String(limit) });
  if (offset > 0) params.set("offset", String(offset));
  return `/leaderboard?${params.toString()}`;
}

export function buildTotalLeaderboardPath(provider, limit = 100, offset = 0) {
  const params = new URLSearchParams({ provider, limit: String(limit) });
  if (offset > 0) params.set("offset", String(offset));
  return `/leaderboard/total?${params.toString()}`;
}

export function buildPeriodLeaderboardPath(period, anchor, provider, limit = 100, offset = 0) {
  const params = new URLSearchParams({ period, anchor, provider, limit: String(limit) });
  if (offset > 0) params.set("offset", String(offset));
  return `/leaderboard?${params.toString()}`;
}

export function buildMeUploadsPath(from, to, provider) {
  const params = new URLSearchParams({ from, to, provider });
  return `/me?${params.toString()}`;
}

export function buildMyTotalPath(provider) {
  const params = new URLSearchParams({ provider });
  return `/me/total?${params.toString()}`;
}

export function buildMyPeriodPath(period, anchor, provider) {
  const params = new URLSearchParams({ period, anchor, provider });
  return `/me/leaderboard?${params.toString()}`;
}

export function shiftLeaderboardAnchor(anchor, period, direction) {
  const date = new Date(`${anchor}T00:00:00.000Z`);
  if (period === "day") {
    date.setUTCDate(date.getUTCDate() + direction);
  } else if (period === "week") {
    date.setUTCDate(date.getUTCDate() + direction * 7);
  } else if (period === "month") {
    date.setUTCDate(1);
    date.setUTCMonth(date.getUTCMonth() + direction);
  } else if (period === "quarter") {
    date.setUTCDate(1);
    date.setUTCMonth(Math.floor(date.getUTCMonth() / 3) * 3 + direction * 3);
  } else if (period === "year") {
    date.setUTCMonth(0, 1);
    date.setUTCFullYear(date.getUTCFullYear() + direction);
  }
  return date.toISOString().slice(0, 10);
}

export function leaderboardWindowLabel(window) {
  if (!window) return "";
  if (window.period === "week") return `${window.startDate} 至 ${window.endDate}`;
  if (window.period === "month") return `${window.startDate.slice(0, 4)} 年 ${Number(window.startDate.slice(5, 7))} 月`;
  if (window.period === "quarter") {
    return `${window.startDate.slice(0, 4)} 年第 ${Math.floor((Number(window.startDate.slice(5, 7)) - 1) / 3) + 1} 季度`;
  }
  return `${window.startDate.slice(0, 4)} 年`;
}

export function createLeaderboardMetrics({
  mode = "day",
  leaderboard,
  myUploads,
  myYearUploads,
  myPeriod,
  myTotal,
  user,
  date,
  eligibleCount,
  activeCount,
  activeTokenTotal,
}) {
  const myUsage = myUploads.find((item) => item.date === date) ?? null;
  const boardRank = leaderboard.find((item) => item.user?.id === user?.id)?.rank ?? null;
  const myAggregate = mode === "total" ? myTotal : mode === "day" ? null : myPeriod;
  const myRank = myAggregate?.rank ?? boardRank;
  const activeItems = leaderboard.filter((item) => item.totalTokens > 0);
  const pageTokenTotal = activeItems.reduce((sum, item) => sum + item.totalTokens, 0);
  const participantCount = activeCount ?? activeItems.length;
  const totalTokens = activeTokenTotal ?? pageTokenTotal;
  const averageTokens = participantCount ? totalTokens / participantCount : null;
  const yearTotal = Array.isArray(myYearUploads)
    ? myYearUploads.filter((item) => item.date <= date).reduce((sum, item) => sum + item.totalTokens, 0)
    : null;
  return {
    myUsage,
    myRank,
    myAggregate,
    myPeriod,
    myTotal,
    totalTokens,
    averageTokens,
    participantCount,
    eligibleCount: eligibleCount ?? leaderboard.length,
    yearTotal,
  };
}
